import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppConfig } from '@config/app.config';
import { LANGUAGE_CONFIG } from '@config/language.config';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { DEFAULT_INTERRUPTSOURCES, Idle } from 'ng2-idle-core';
import { delay, filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public isLoggedIn = false;
  public isMenuIn = false;
  public itemMenu = false;
  public errorLogin = false;
  readonly timeOutValue: number = this.appConfig.ALERT_INACTIVE_TIME;

  public timer: any;
  public content: any;
  public loadingParent: any;
  public app: any;

  constructor(
    public appConfig: AppConfig,
    public generalsService: GeneralsService,
    public authenticationService: AuthenticationService,
    public idle: Idle,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    private elementRef: ElementRef
  ) {
    this.authenticationService.isLoggedIn
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(result => {
        this.isLoggedIn = result;
        if (!result) {
          this.itemMenu = true;
          this.generalsService.clearMenu();
        }
      });

    this.idle.setIdle(this.appConfig.INACTIVE_TIME);
    this.idle.setTimeout(this.appConfig.ALERT_INACTIVE_TIME);
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.reset();

    this.idle.onTimeout
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(() => {
        this.authenticationService.logout();
      });

    this.idle.onIdleStart
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe(() => {
        this.generalsService.notification(
          this.appConfig.NOTIFICATION.info,
          LANGUAGE_CONFIG.message.textSession.replace(
            '{SECOND}',
            this.timeOutValue.toString()
          )
        );
      });

    this.reset();
  }

  ngOnInit() {
    this.elementRef.nativeElement.removeAttribute('ng-version');
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.constants.destroy$)
      )
      .subscribe(() => {
        this.processActions();
      });

    this.generalsService.itemMenu$
      .pipe(
        takeUntil(this.constants.destroy$),
        delay(0)
      )
      .subscribe(result => {
        if (result.status !== undefined) {
          this.constants.errorText = this.generalsService.showError(result);
          this.errorLogin = true;
        } else {
          this.itemMenu = true;
        }
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  reset() {
    if (this.isLoggedIn) {
      this.idle.watch();
    }
  }

  processActions() {
    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        if (result && this.router.url.indexOf('login') < 0) {
          this.processDocument();
          const root: ActivatedRoute = this.activatedRoute.root;
          this.generalsService.getBreadcrumbs(root);
        } else {
          this.processDocument();
        }
      });
  }

  processDocument() {
    this.setDocument();
    if (this.loadingParent) {
      clearTimeout(this.timer);
      this.loadingParent.style.transition = '0.5s';
      this.loadingParent.style.opacity = '0';
      this.app.style.display = 'inline';

      this.timer = setTimeout(() => {
        this.content.removeChild(this.loadingParent);
      }, 500);
    }
  }

  setDocument() {
    this.content = document.getElementById('content');
    this.loadingParent = document.getElementById('loading-parent');
    this.app = document.getElementById('app');
  }
}
